import * as CL from '@design-system/component-library';
import { OFZeroPriceReasons } from '../../../../generated/api/oFZeroPriceReasons';
import { OFZeroPricingDetails } from '../../../../generated/api/oFZeroPricingDetails.js';
import { OpenFormGridCol, OpenFormGridRow } from '../../OpenFormComponents/OpenFormGrid.js';
import { OpenFormQuestionInput } from '../OpenFormQuestion/OpenFormQuestionInput.js';
import {
  additionalPricingInformationMsg,
  openFormZeroPriceDetailsLabelMsg,
  openFormZeroPriceInfoPart1Msg,
  openFormZeroPriceInfoPart2Msg,
  openFormZeroPriceInfoPart3Msg,
  openFormZeroPriceInfoPart4Msg,
  openFormZeroPriceReasonLabelMsg,
  openFormZeroPriceReasonOption10Msg,
  openFormZeroPriceReasonOption11Msg,
  openFormZeroPriceReasonOption12Msg,
  openFormZeroPriceReasonOption1Msg,
  openFormZeroPriceReasonOption2Msg,
  openFormZeroPriceReasonOption3Msg,
  openFormZeroPriceReasonOption4Msg,
  openFormZeroPriceReasonOption5Msg,
  openFormZeroPriceReasonOption6Msg,
  openFormZeroPriceReasonOption7Msg,
  openFormZeroPriceReasonOption8Msg,
  openFormZeroPriceReasonOption9Msg,
  orMsg,
  requiredInformationMsg,
  t,
} from '../../../../common/i18n';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export const zeroDetailsQuestion = { guid: 'zeroPriceDetails' };

export const zeroReasonQuestion = {
  guid: 'zeroPriceReason',
  options: [
    {
      label: t.GBQ9(openFormZeroPriceReasonOption1Msg),
      value: OFZeroPriceReasons.TECHNICAL_SERVICE_RELATED_TO_END_CUSTOMER,
    },
    {
      label: t.YN8I(openFormZeroPriceReasonOption2Msg),
      value: OFZeroPriceReasons.BILLED_AS_PART_OF_BUNDLE,
    },
    {
      label: t.MQSD(openFormZeroPriceReasonOption3Msg),
      value: OFZeroPriceReasons.BILLING_HANDLED_BY_ANOTHER_CRM,
    },
    {
      label: t.IVOS(openFormZeroPriceReasonOption4Msg),
      value: OFZeroPriceReasons.BRAND_DEVELOPMENT_AND_SALES_PROMOTION,
    },
    {
      label: t.G0Q0(openFormZeroPriceReasonOption5Msg),
      value: OFZeroPriceReasons.BILLING_TEMPORARILY_BLOCKED,
    },
    {
      label: t.Z2LJ(openFormZeroPriceReasonOption6Msg),
      value: OFZeroPricingDetails.ROAMING_SERVICES_IN_TESTING,
    },
    {
      label: t.NNF2(openFormZeroPriceReasonOption7Msg),
      value: OFZeroPriceReasons.SERVICES_USED_BY_SUBCONTRACTORS,
    },
    {
      label: t.H4C9(openFormZeroPriceReasonOption8Msg),
      value: OFZeroPriceReasons.TAXABLE_EMPLOYEE_SUBSCRIPTIONS,
    },
    {
      label: t.D2GQ(openFormZeroPriceReasonOption9Msg),
      value: OFZeroPriceReasons.EMPLOYEE_TEST_SERVICES,
    },
    {
      label: t.FWP8(openFormZeroPriceReasonOption10Msg),
      value: OFZeroPriceReasons.PRODUCTION_CONNECTIONS,
    },
    {
      label: t.KNVH(openFormZeroPriceReasonOption11Msg),
      value: OFZeroPriceReasons.DEMO_SERVICES_IN_STORE,
    },
    {
      label: t.VOMQ(openFormZeroPriceReasonOption12Msg),
      value: OFZeroPriceReasons.TEMPORARY_EVENT_SERVICES,
    },
  ],
};

const zeroReasonItems = zeroReasonQuestion.options.map(({ label, value }) => ({
  id: value,
  value: value,
  label: label,
  html: <span>{label}</span>,
}));

export const OpenFormZeroPrice = ({ disabled }: { disabled: boolean }) => {
  const { setValue, getValues, unregister } = useFormContext();

  useEffect(() => {
    return () => {
      unregister(zeroDetailsQuestion.guid);
      unregister(zeroReasonQuestion.guid);
    };
  }, [unregister]);

  return (
    <>
      <OpenFormGridRow className="of-openform__view__zero-price">
        <OpenFormGridCol colWidth={9}>
          <OpenFormGridRow justifyCenter={false}>
            <OpenFormGridCol className="of-openform__view__zero-price__inner" colWidth={7}>
              <br />
              <br />
              <div>
                <h4 style={{ display: 'inline', margin: 0, padding: 0 }}>{t.OSYL(additionalPricingInformationMsg)}</h4>
                <span style={{ display: 'inline' }}> {t.LYWB(requiredInformationMsg)}</span>
              </div>
              <br />
              <div>
                <span>
                  {t.E3AN(openFormZeroPriceInfoPart1Msg)}{' '}
                  <CL.Link
                    linkHref="https://elisacorporation.sharepoint.com/sites/intranet_fi-prosessit/sitepages/Laskutusestetyt-ja-nollahintaiset-palvelut-(Elisa-Oyj).aspx"
                    linkTarget="_blank"
                  >
                    {t.JPFF(openFormZeroPriceInfoPart2Msg)}
                  </CL.Link>{' '}
                  {t.K4LF(orMsg)}{' '}
                  <a
                    href="https://elisa.lightning.force.com/lightning/r/Knowledge__kav/ka0Tt000000hyddIAA/view"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t.XAWP(openFormZeroPriceInfoPart3Msg)}
                  </a>{' '}
                  {t.Z8FX(openFormZeroPriceInfoPart4Msg)}
                </span>
              </div>

              <br />
              <CL.Combobox
                inputProps={{ autoCapitalize: 'off', autoComplete: 'off', autoCorrect: 'off' }}
                items={zeroReasonItems}
                label={t.VOMQ(openFormZeroPriceReasonLabelMsg)}
                selectedItemFormat="html"
                selectedValue={getValues(zeroReasonQuestion.guid) ?? ''}
                onValueSelect={value => setValue(zeroReasonQuestion.guid, value)}
              />

              <OpenFormQuestionInput
                wrapperClassName="zeroprice"
                disabled={disabled}
                name={zeroDetailsQuestion.guid}
                required={false}
                wrapGridRow={false}
                colWidth={12}
                type="textarea"
                label={t.UTNT(openFormZeroPriceDetailsLabelMsg)}
              ></OpenFormQuestionInput>
            </OpenFormGridCol>
          </OpenFormGridRow>
        </OpenFormGridCol>
      </OpenFormGridRow>
    </>
  );
};
